import { useMemo } from 'react';

const useLegalRepresentativeText = (regime) => {
  const textForLegalRepresentative = useMemo(
    () => (regime === 'moral' ? 'representante legal del' : ''),
    [regime]
  );
  return textForLegalRepresentative;
};

export default useLegalRepresentativeText;
